import classNames from 'classnames';
import { IconClose } from '@/components/svg-symbols/icons';
export interface TagProps {
  style: 'filled' | 'outlined';
  state: 'yellow' | 'gray' | 'green' | 'red' | 'pink' | 'blue';
  children: string;
  handleClose?: () => void;
}
export const Tag = ({
  style,
  state,
  children,
  handleClose
}: TagProps) => {
  return <div role='button' onClick={handleClose} className={classNames('flex w-fit items-center justify-center gap-0.5 rounded border px-2 py-1 text-caption-12', {
    'cursor-pointer pl-1': handleClose,
    'text-alert-warning-dark': state === 'yellow',
    'border-alert-warning-light bg-alert-warning-light': state === 'yellow' && style === 'filled',
    'border-alert-warning-dark': state === 'yellow' && style === 'outlined',
    'text-text-darkGray': state === 'gray',
    'border-gray-300 bg-gray-300': state === 'gray' && style === 'filled',
    'border-text-mediumGray': state === 'gray' && style === 'outlined',
    'text-alert-success-dark': state === 'green',
    'border-alert-success-light bg-alert-success-light': state === 'green' && style === 'filled',
    'border-alert-success-dark': state === 'green' && style === 'outlined',
    'text-alert-error-dark': state === 'red',
    'border-alert-error-light bg-alert-error-light': state === 'red' && style === 'filled',
    'border-alert-error-dark': state === 'red' && style === 'outlined',
    'text-primary-main': state === 'pink',
    'border-primary-shade-50 bg-primary-shade-50': state === 'pink' && style === 'filled',
    'border-primary-main': state === 'pink' && style === 'outlined',
    'text-alert-info-dark': state === 'blue',
    'border-alert-info-light bg-alert-info-light': state === 'blue' && style === 'filled',
    'border-alert-intext-alert-info-dark': state === 'blue' && style === 'outlined'
  })} data-sentry-component="Tag" data-sentry-source-file="tag.tsx">
            <span>{children}</span>

            {handleClose && <IconClose className='h-4 w-4' />}
        </div>;
};